<style lang="stylus">
    .redpoint-box
        position relative
        display block
        &.redActive::after
            content ''
            position absolute
            right 5px
            top 5px
            width 5px
            height 5px
            border-radius 50%
            background #F34036
</style>

<template>
    <span ref="redPointBox" class="redpoint-box" :class="{ redActive: activePoint }" @click="clickRedPoint()">
        <slot></slot>
    </span>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({})
    export default class RedPoint extends Vue {
        @Prop()
        pointName;
        @Prop({ default: "" })
        parentName;
        @Prop({ default: () => [] })
        childrenList;
        @Prop({ default: 1591401600000 }) // 2020-06-06 08:00
        create_time;

        activePoint: boolean = false;
        clickRedPoint() {
            console.log(this.pointName);
            let pointList = this.getLocalStorageData();
            for (let i = 0; i < pointList.length; i++) {
                if (pointList[i].name == this.pointName) {
                    if (pointList[i].children.length == 0) {
                        pointList[i].checked = true;
                        this.activePoint = false;
                        this.setLocalStorageData(pointList);
                        if (pointList[i].parent != "") {
                            this.$bus.$emit("clickRedPoint", pointList[i].parent);
                        }
                        break;
                    } else {
                        break;
                    }
                }
            }
        }
        checkRedPoint() {
            // true显示红点，false隐藏红点
            let pointList = this.getLocalStorageData();
            let pointNameList = [];
            let flag = true;
            let checkChildren = (list) => {
                let result = [];
                for (let i = 0; i < list.length; i++) {
                    for (let j = 0; j < pointList.length; j++) {
                        if (list[i] == pointList[j].name) {
                            result.push(pointList[j].checked);
                            break;
                        }
                    }
                }
                return result;
            };
            for (let i = 0; i < pointList.length; i++) {
                if (pointList[i].name == this.pointName) {
                    if (this.checkTime(pointList[i].create_time)) {
                        return false;
                    } else if (pointList[i].children.length == 0) {
                        if (pointList[i].checked) {
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        let checkChild = checkChildren(pointList[i].children);
                        if (checkChild.length == 0) {
                            return true;
                        } else {
                            let flag = checkChild.reduce((a, b) => a && b, true);
                            if (flag) {
                                pointList[i].checked = true;
                                this.setLocalStorageData(pointList);
                            }
                            return !flag; // 子节点的checked状态取并集，全部为true时返回false隐藏红点
                        }
                    }
                }
            }
        }
        addRedPoint() {
            let pointList = this.getLocalStorageData();
            let pointNameList = [];
            for (let i = 0; i < pointList.length; i++) {
                pointNameList.push(pointList[i].name);
            }
            if (pointNameList.includes(this.pointName)) {
                return;
            } else {
                pointList.push({
                    name: this.pointName,
                    parent: this.parentName,
                    children: this.childrenList,
                    create_time: this.create_time,
                    checked: false,
                });
                this.setLocalStorageData(pointList);
                if (this.parentName) {
                    this.$bus.$emit("clickRedPoint", this.parentName);
                }
            }
        }
        checkTime(time) {
            // 是否超过两周，是返回true
            let now = new Date().getTime();
            let twoWeek = 1209600000;
            if (now - twoWeek > time) {
                return true;
            }
        }
        setLocalStorageData(data) {
            window.localStorage.setItem("redPointList", JSON.stringify(data));
        }
        getLocalStorageData() {
            return JSON.parse(window.localStorage.getItem("redPointList")) || [];
        }
        init() {
            this.addRedPoint();
            this.activePoint = this.checkRedPoint();
        }
        mounted() {
            this.init();
        }
        created() {
            this.$bus.$on("clickRedPoint", (data) => {
                // 点击子节点，传递父节点名称
                if (data == this.pointName) {
                    this.activePoint = this.checkRedPoint();
                    if (this.parentName) {
                        this.$bus.$emit("clickRedPoint", this.parentName);
                    }
                }
            });
        }
        beforeDestroy() {
            this.$bus.$off("clickRedPoint");
        }
    }
</script>
